import * as yup from 'yup';

export const supportFeedbackValidationSchema = yup.object({
    Message: yup
    .string()
    .nullable()
    .required('Description is required')
    .max(950, 'Max character limit of 950 reached'),
});